import React from 'react'

interface SurveyOrderResult {
    rankInDepartment: number
    totalInDepartment: number
    rankInFaculty: number
    totalInFaculty: number
    rankInUniversity: number
    totalInUniversity: number
}

interface SurveyOrderResultProps {
    result: SurveyOrderResult | null
}

const SurveyOrderResultComponent: React.FC<SurveyOrderResultProps> = ({ result }) => {
    if (!result) return null

    return (
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <h3>Sıralama Bilgileri</h3>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '3rem', flexWrap: 'wrap' }}>
                <div><strong>Bölüm:</strong> {result.rankInDepartment} / {result.totalInDepartment}</div>
                <div><strong>Fakülte:</strong> {result.rankInFaculty} / {result.totalInFaculty}</div>
                <div><strong>Üniversite:</strong> {result.rankInUniversity} / {result.totalInUniversity}</div>
            </div>
        </div>
    )
}

export default SurveyOrderResultComponent
